import { Close } from '@carbon/icons-react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import * as Preact from 'preact';
import * as ArCard from './A_ARDesktopBasket';
import { ArProps, QrProps } from './O_ArModal';

export interface Props {
    open: boolean;
    onCloseClick: () => void;
}

export const Component = (p: Props & (ArProps | QrProps)) => {
    return (
        <Dialog
            open={p.open}
            onClose={p.onCloseClick}
            BackdropProps={{
                style: {
                    borderRadius: '24px',
                    right: 0,
                    maxWidth: 'calc(100% - 72px)',
                    backgroundColor: 'rgba(34, 33, 76, 0.2)',
                },
            }}
            sx={{ maxWidth: 'calc(100% - 72px)' }}
            PaperProps={{
                sx: {
                    position: 'absolute',
                    top: 'auto',
                    left: 0,
                    right: 0,
                    margin: 'auto',
                    bottom: '44px',
                    display: 'flex',
                    flexDirection: 'row',
                    backgroundColor: 'transparent',
                    alignItems: 'flex-start',
                    gap: '8px',
                    width: '400px',
                },
            }}
        >
            {p.mode === 'qr' && <ArCard.Component loading={p.loading} qrUrl={p.qrCode} />}
            <IconButton size="small" color="secondary" onClick={p.onCloseClick}>
                <Close size={20} />
            </IconButton>
        </Dialog>
    );
};

Component.displayName = 'ArModal';
